export var ExpectationUnit;

(function (ExpectationUnit) {
  ExpectationUnit["Percentage"] = "percentage";
  ExpectationUnit["Score"] = "score";
})(ExpectationUnit || (ExpectationUnit = {}));